import ProdModel from '@/models/Prod';

const CLAER_SEARCH_PROD_LIST = 'CLAER_SEARCH_PROD_LIST';
const GET_SEARCH_PROD_PAGING_LIST = 'GET_SEARCH_PROD_PAGING_LIST';

/**
 * 清除搜索产品结果
 */
async function clearSearchProdList() {
  return {
    type: CLAER_SEARCH_PROD_LIST,
  }
}

/**
 * 获取搜索产品结果列表(分页)
 */
async function getSearchProdPagingList(params) {
  const payload = await new ProdModel().searchProdPagingList(params);
  return {
    type: GET_SEARCH_PROD_PAGING_LIST,
    payload: {
      ...payload,
      searchParams: params
    }
  }
}

const ACTION_TYPES = {
  CLAER_SEARCH_PROD_LIST,
  GET_SEARCH_PROD_PAGING_LIST,
};

const ACTION = {
  clearSearchProdList,
  getSearchProdPagingList,
};

const SearchProd = {
  ACTION_TYPES,
  ACTION
}

export default SearchProd;